import * as React from 'react';
import { InView } from 'react-intersection-observer';
import { Box, CircularProgress } from '@mui/material';
import isFunction from 'lodash/isFunction';

interface IProps<T, D> {
    list: T[];
    loadMore: () => Promise<D>;
    dataListGetter?: (data: D) => T[];
    hasNext: boolean;
    isLoading: boolean;
    children: (list: T[]) => React.ReactNode;
}

export function InfiniteLoader<T, D>({ list, loadMore, isLoading, hasNext, children }: IProps<T, D>) {
    const handleOnView = React.useCallback(
        async (inView: boolean) => {
            if (!isLoading && inView && hasNext) {
                await loadMore();
            }
        },
        [hasNext, isLoading, loadMore]
    );

    return (
        <>
            {isFunction(children) && children(list)}
            {hasNext && (
                <InView onChange={handleOnView}>
                    {({ inView, ref }) => (
                        <div ref={ref}>
                            <Box display="flex" paddingY={1} justifyContent="center">
                                {inView && <CircularProgress variant="indeterminate" />}
                            </Box>
                        </div>
                    )}
                </InView>
            )}
        </>
    );
}
